var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.908,
    height: 22.908,
    viewBox: "0 0 22.908 22.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.454,24.908A11.454,11.454,0,1,0,2,13.454,11.454,11.454,0,0,0,13.454,24.908ZM17.5,9.4a1.146,1.146,0,1,1,1.62,1.622L12.649,17.5l0,0a1.142,1.142,0,0,1-1.62,0l0,0L7.784,14.265a1.145,1.145,0,1,1,1.62-1.62l2.43,2.43,5.67-5.67Z",
    transform: "translate(-2 -2)",
    fill: "#0533b3",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPrimary);
export default __webpack_public_path__ + "static/media/check-primary.8f4d0bbeac4c1fb6ea88b8a70c64358b.svg";
export { ForwardRef as ReactComponent };